// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"68ceed69","266":"62a8a0e3"}[chunkId] + ".chunk.css";
};